import React, { useEffect, useState } from 'react';
import UserClubs from '../home/all-clubs';
import { useAsyncError, useLocation } from 'react-router-dom';
import createAxiosInstance from '../../api/axiosConfig';
import { CLUBS_BY_ID } from '../../api/endpoint';

const Clubs = () => {
  const location = useLocation();
  const { userDetail, userId, handle } = location.state || {};
  const [pagekey, setPageKey] = useState('');
  const [userClubs, setUserClubs] = useState([]);

  const fetchUserClubs = async () => {
    try {
      const axiosInstance = createAxiosInstance(false);
      const response = await axiosInstance.get(`${CLUBS_BY_ID}${userId}&page=${pagekey}&count=`);
      if (response) {
        setUserClubs(response.data.data);
      }
    } catch (error) {
      console.error('Error fetching user books:', error);
    }
  };

  useEffect(() => {
    if (userId) {
      fetchUserClubs();
    }
  }, [pagekey]);

  return (
    <div>
      <UserClubs userClubs={userClubs} handle={handle}></UserClubs>
    </div>
  );
};
export default Clubs;
